import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-brand">
          <h2>Soloway</h2>
          <p>
            Soloway is Sri Lanka's dedicated travel platform connecting global travelers with certified local guides, verified boutique hotels, and essential services like tourist visa assistance and travel insurance.
          </p>
        </div>

        <div className="footer-links">
          {/* Column 1: Explore Stays */}
          <div className="link-column">
            <span className="column-title">Sri Lanka Hotels</span>
            <ul>
              <li><Link to="/hotels">All Hotels & Stays</Link></li>
              <li><Link to="/hotels/ella">Ella Hotels & Villas</Link></li>
              <li><Link to="/hotels/sigiriya">Sigiriya Eco Lodges</Link></li>
              <li><Link to="/hotels/colombo">Colombo City Hotels</Link></li>
              <li><Link to="/hotels/galle">Galle Fort Boutiques</Link></li>
            </ul>
          </div>

          {/* Column 2: Local Guides */}
          <div className="link-column">
            <span className="column-title">Tour Guides</span>
            <ul>
              <li><Link to="/guides">Certified Guides Directory</Link></li>
              <li><Link to="/guides?category=wildlife-guides">Wildlife & Safari Trackers</Link></li>
              <li><Link to="/guides?category=heritage-guides">Cultural Heritage Guides</Link></li>
              <li><Link to="/guides?category=chauffeur-guides">Private Chauffeur Drivers</Link></li>
            </ul>
          </div>

          {/* Column 3: Business Policies & Legal Compliance */}
          <div className="link-column">
            <span className="column-title">Policies & Legal</span>
            <ul>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/return-policy">Return & Refund Policy</Link></li>
              <li><Link to="/policies?tab=payments">Payment Terms & Methods</Link></li>
              <li><Link to="/policies">Platform Governance</Link></li>
            </ul>
          </div>

          {/* Column 4: Partner & Account */}
          <div className="link-column">
            <span className="column-title">Partner with Soloway</span>
            <ul>
              <li><Link to="/register">Register as Traveler</Link></li>
              <li><Link to="/become-hotel-owner">List Your Hotel</Link></li>
              <li><Link to="/become-guide">Join as Licensed Guide</Link></li>
              <li><Link to="/login">Partner Sign In</Link></li>
              <li><Link to="/admin/login" style={{ fontWeight: "600", color: "#0f6eb5" }}>Admin Portal Login</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <span>© {new Date().getFullYear()} SOLOWAY.LK (PVT) LTD. All rights reserved. Sri Lanka Tourism Platform.</span>
          <span className="footer-admin-separator">•</span>
          <Link to="/terms-and-conditions" className="footer-admin-link">Terms</Link>
          <span className="footer-admin-separator">•</span>
          <Link to="/privacy-policy" className="footer-admin-link">Privacy</Link>
          <span className="footer-admin-separator">•</span>
          <Link to="/return-policy" className="footer-admin-link">Refund Policy</Link>
          <span className="footer-admin-separator">•</span>
          <Link to="/admin/login" className="footer-admin-link">Admin Login</Link>
        </div>
        <div className="footer-socials">
          <a href="https://facebook.com/soloway" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://instagram.com/soloway" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://twitter.com/solowaylk" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
            <IoMdClose />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;